module.exports = __webpack_public_path__ + "230b25be62643c63ae1e8ad544c8af86.jpg";